
import { useFrank, formatTime } from "@/hooks/useFrank";
import MessageList from "@/components/frank/MessageList";
import MessageInput from "@/components/frank/MessageInput";
import LanguageSelector from "@/components/frank/LanguageSelector";
import { useIsMobile } from "@/hooks/use-mobile";
import { useLanguage } from "@/contexts/LanguageContext";
import { useManagerAuth } from "@/hooks/useManagerAuth";

const AskFrank = () => {
  const { member } = useManagerAuth();
  
  const {
    messages,
    newMessage,
    setNewMessage,
    isLoading,
    isInitializing,
    messagesEndRef,
    handleSendMessage,
    connectionError,
    apiStatus,
    currentApiUrl,
    retryInitialization
  } = useFrank(member);
  const isMobile = useIsMobile();
  const { t } = useLanguage();

  return (
    <div 
      className="relative flex size-full min-h-screen flex-col bg-white group/design-root overflow-x-hidden pb-20 md:pb-0"
      style={{ fontFamily: 'Newsreader, "Noto Sans", sans-serif' }}
    >
      <div className="layout-container flex h-full grow flex-col">
        <div className="px-4 md:px-10 lg:px-40 flex flex-1 justify-center py-5">
          <div className="layout-content-container flex flex-col max-w-[960px] flex-1">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-[#111418] tracking-light text-2xl font-bold leading-tight px-4 text-center flex-1">
                {t('nav.ask_frank')}
              </h3>
              <div className="flex items-center gap-2 md:hidden">
                <LanguageSelector />
                {isMobile && (
                  <div className="text-xs opacity-70">Mobile</div>
                )}
              </div>
            </div>
            
            <div className="flex-1 flex flex-col pb-20">
              {isInitializing ? (
                <div className="flex-1 flex items-center justify-center">
                  <div className="text-center space-y-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
                    <p className="text-muted-foreground">Initializing Frank AI...</p>
                  </div>
                </div>
              ) : connectionError ? (
                <div className="flex-1 flex items-center justify-center">
                  <div className="text-center space-y-4 max-w-md px-4">
                    <div className="text-destructive font-medium">Connection Error</div>
                    <p className="text-muted-foreground text-sm">{connectionError}</p>
                    <button
                      onClick={retryInitialization}
                      className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
                    >
                      Retry Connection
                    </button>
                  </div>
                </div>
              ) : (
                <MessageList
                  messages={messages}
                  isLoading={isLoading}
                  messagesEndRef={messagesEndRef}
                  formatTime={formatTime}
                  connectionError={connectionError}
                  apiStatus={apiStatus}
                  currentApiUrl={currentApiUrl}
                  member={member}
                />
              )}
            </div>
            
            <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#f0f2f4] z-10 pb-20 md:pb-0">
              <div className="px-4 md:px-10 lg:px-40 flex justify-center">
                <div className="max-w-[960px] w-full">
                  <MessageInput
                    newMessage={newMessage}
                    setNewMessage={setNewMessage}
                    handleSendMessage={handleSendMessage}
                    isLoading={isLoading}
                    disabled={apiStatus === 'unavailable' || isInitializing}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AskFrank;
